module.exports = __webpack_public_path__ + "static/media/icon_x_blue.41848653.svg";